// Route Code Edited 5/5/26
/**
 * Route T&C/Checkbox Handler
 *
 * PROBLEM: Route's native checkout process doesn't validate custom checkboxes
 * (e.g., age verification, terms & conditions) before proceeding to checkout.
 *
 * SOLUTION: Intercepts clicks on Route's checkout button to validate required
 * checkboxes. If validation fails, redirects to the rterms disable element to 
 * trigger message.
 *
 * Configuration Selectors:
 * - routeCheckout: Route's cloned checkout button
 * - routeCWC: Route's "Continue Without Coverage" link
 * - cartContainer: Optional array of cart container selectors to scope search
 *   • Limits checkbox/button search to specific cart areas
 *   • If empty, entire document is searched
 *   • Example: ['#cart-drawer', '.cart-page-checkout-container']
 * - requiredCheckboxes: Array of checkbox selectors that must be checked
 *   • Missing checkboxes are treated as valid (won't block checkout)
 *   • Example: ['#age-verification', '.terms-checkbox input', '[name="agree"]']
 *
 */
const config = {
  selectors: {
    rTermsEl: '.rterms-disable',
    routeCheckout: '[data-route-cloned-button]',
    routeCWC: '.route-continue-without-coverage-link',
    cartContainer: ['#halo-cart-sidebar .previewCartGroup'],
    requiredCheckboxes: ['.rterms-checkbox']
  }
};

const { selectors } = config;

const ROUTE_BUTTON_SELECTOR = `${selectors.routeCheckout}, ${selectors.routeCWC}`;

document.addEventListener("click", (event) => {
  const clickedRouteButton = event.target.closest(ROUTE_BUTTON_SELECTOR);
  if (!clickedRouteButton) return;

  // Determine search scope (nearest cart container or entire document).
  const containerElement = selectors.cartContainer.length
    ? selectors.cartContainer.reduce((found, selector) =>
        found || clickedRouteButton.closest(selector), null)
    : null;
  const searchContext = containerElement ?? document;

  // Check if all required checkboxes are checked.
  // Missing checkboxes are treated as valid — this prevents blocking checkout
  // if an optional checkbox isn't rendered on a particular page.
  const allCheckboxesChecked = selectors.requiredCheckboxes.every(checkboxSelector => {
    const checkbox = searchContext.querySelector(checkboxSelector);
    return checkbox?.checked ?? true;
  });

  // Allow Route's normal behavior if validation passes
  if (allCheckboxesChecked) return;

  // Validation failed - find rterms disable elementsl to trigger
  const allRTermsEl = searchContext.querySelectorAll(selectors.rTermsEl);

  if (allRTermsEl.length === 0) {
    console.error(`Route rterms trigger failed: No rterms disable elements found matching selector: ${selectors.rTermsEl}`);
  } else {
    // Block Route's checkout action
    event.preventDefault();
    event.stopImmediatePropagation();

    // Trigger rterms validation message
    allRTermsEl[0].click();
  }
}, { capture: true });
// End Route Code
